/* 筋トレ最安ナビ: 楽天リアルタイム売れ筋ランキングの並べ替え・表示（fitpeak-price-compare から使う）
   順位データ: fitpeak-price-api /rakuten-ranking の ranks（{ 商品ID: { rank, genre_name, url } }） */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.FpcRakutenRank = api;
})(typeof self !== 'undefined' ? self : this, function () {
  // 順位のある商品を順位順に、圏外は元の並び（安い順）のまま後ろへ
  function orderByRank(list, ranks) {
    var r = ranks || {};
    var ranked = list.filter(function (p) { return r[p.id]; }).sort(function (a, b) { return r[a.id].rank - r[b.id].rank; });
    return ranked.concat(list.filter(function (p) { return !r[p.id]; }));
  }
  function label(info) { return info ? '楽天 ' + info.genre_name + ' ' + info.rank + '位' : ''; }
  return { orderByRank: orderByRank, label: label };
});
